export default __webpack_public_path__ + "static/private_2-d73394f73915f051e9f63ee83736fa67.webp";